module.exports = __webpack_public_path__ + "img/01.79628123.png";